const c = (e) => {
  const t = Array.isArray(e == null ? void 0 : e.my_shop_features) ? e.my_shop_features[0] : e == null ? void 0 : e.my_shop_features;
  return {
    componentType: "my_shop_features",
    backgroundColor: t == null ? void 0 : t.background_color,
    features: ((t == null ? void 0 : t.features) || []).map((n, o) => ({
      id: o,
      displayTitle: n.display_title,
      subTitle: n.sub_title,
      image: {
        url: n.image.images[0].image.url,
        viewport: n.image.images[0].viewport,
        altText: n.image.images[0].alt_text
      }
    }))
  };
}, _ = (e) => {
  var o, i, r, l, s;
  const [t] = e.my_shop_article, n = {
    componentType: "my_shop_article",
    image: {
      url: (r = (i = (o = t.image) == null ? void 0 : o.images[0]) == null ? void 0 : i.image) == null ? void 0 : r.url,
      altText: (s = (l = t.image) == null ? void 0 : l.images[0]) == null ? void 0 : s.alt_text
    },
    backgroundColor: t.background_color,
    content: {
      title: "",
      heading_type: "h3",
      alignment: "left",
      content: ""
    }
  };
  return t.text_only.length > 0 && (n.content.title = t.text_only[0].display_title.text, n.content.heading_type = t.text_only[0].display_title.heading_type, n.content.alignment = t.text_only[0].display_title.alignment, n.content.content = t.text_only[0].description), n;
}, m = (e) => {
  const t = Array.isArray(e == null ? void 0 : e.get_started) ? e.get_started[0] : e == null ? void 0 : e.get_started;
  return {
    componentType: "get_started",
    displayTitle: t == null ? void 0 : t.display_title,
    subTitle: t == null ? void 0 : t.sub_title,
    backgroundColor: t == null ? void 0 : t.background_color,
    ctaButton: t == null ? void 0 : t.link
  };
}, p = (e) => {
  const t = e.data;
  if (t) {
    const n = {
      content: "",
      display_title: ""
    }, { text_only: o } = t;
    return o.length > 0 && (n.content = o[0].description, n.display_title = o[0].display_title.text), n;
  }
}, y = (e) => {
  const { products: t = [], max_products: n = 0 } = e ?? {};
  return { products: t, max_products: n };
}, g = (e) => {
  const { default_profile_image: t } = e ?? {};
  return { default_profile_image: t };
};
export {
  g as getDefaultProfileImageCmsDataTransformer,
  y as getProductCmsDataTransformer,
  p as getRichContentTransformer,
  m as transformGetStarted,
  _ as transformMyShopArticles,
  c as transformMyShopFeatures
};
//# sourceMappingURL=cmsTransformer.js.map
